import { DraggingSelectorMousePos } from './Helpers';
import {
	DragSelectMouseDownType,
	DragSelectMousePositionType,
	DragSelectMouseUpType,
	DragSelectSelectedType,
} from '../Types/SharedFunctions/DragAndDropTypes';

const DragSelectMousePos = (props: DragSelectMousePositionType) => {
	if (props.mouseDownRef.current && props.dragSelectorRef.current) {
		props.disableFolderSelectionCallback(true);

		DraggingSelectorMousePos({
			e: props.event,
			draggerRef: props.dragSelectorRef,
			dragPos: props.dragPositionRef,
			mailBoxesRef: props.mailBoxesRef,
			isLarge: props.enabled,
			draggerPositionCallback: (draggerRef) => props.draggerPositionCallback(draggerRef),
		});
	}
};

const DragSelectMouseDown = (props: DragSelectMouseDownType) => {
	const target = props.event.target as HTMLDivElement;

	if (target && target.matches('.item-content-files') && props.event.button === 0) {
		props.event.preventDefault();

		const parentContainer = props.mailBoxesRef.current?.getBoundingClientRect();

		props.mouseDownCallback({
			state: true,
			startX: parentContainer ? props.event.pageX - parentContainer.left : props.event.pageX,
			startY: parentContainer && !props.enabled ? props.event.pageY - parentContainer.top : props.event.pageY,
		});
	}
};

const DragSelectShiftKeyMouseUp = (props: DragSelectMouseUpType) => {
	const shiftSelectedItems = document.querySelectorAll('.item-shift-active');

	if (props.shiftKeyDownRef.current && shiftSelectedItems && shiftSelectedItems.length > 0) {
		shiftSelectedItems.forEach((item) => props.toggleSelectedCallback(item.getAttribute('data-item-id') as string));
	}

	props.mouseDownCallback(false);

	setTimeout(() => {
		props.disableFolderSelectionCallback(false);
	}, 200);
};

const DragSelectSelected = (props: DragSelectSelectedType) => {
	const dragSelectedItems = document.querySelectorAll('.item-drag-selected');

	dragSelectedItems.forEach((item) => props.toggleSelectedCallback(item.getAttribute('data-item-id') as string));

	props.draggingWasActiveCallback(false);
};

export { DragSelectMousePos, DragSelectMouseDown, DragSelectShiftKeyMouseUp, DragSelectSelected };
